/* src/assets/styles/common.css */
.flex {
  display: flex;
}
.flex-row {
  flex-direction: row;
}
.flex-column {
  flex-direction: column;
}
.flex.jc-e {
  justify-content: end;
}
.flex.jc-c {
  justify-content: center;
}
.flex.jc-sb {
  justify-content: space-between;
}
.flex.align-c {
  align-items: center;
}
.flex.align-fe {
  align-items: flex-end;
}
.flex.align-fs {
  align-items: flex-start;
}
.flex.gap-10 {
  gap: 10px;
}
.flex.gap-20 {
  gap: 20px;
}
.flex.gap-50 {
  gap: 50px;
}
.ac-fs {
  align-content: flex-start;
}
.text-align-center {
  text-align: center;
}
.text-align-right {
  text-align: right;
}
.container {
  padding: 1rem;
}
.mg-t-5 {
  margin-top: 5px;
}
.mg-t-10 {
  margin-top: 10px;
}
.mg-r-10 {
  margin-top: 20px;
}
.width100 {
  width: 100%;
}
.width90 {
  width: 90%;
}
.bold {
  font-weight: 800;
}
.col-1 {
  width: calc(100% * 1 / 12);
}
.col-2 {
  width: calc(100% * 2 / 12);
}

/* src/app/modules/portal/components/app/app.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--base-1);
  overflow-x: visible;
}
sh-access-bar {
  position: fixed;
  top: 0px;
  width: 100%;
}
sh-nav-bar {
  position: fixed;
  bottom: 0px;
  padding-bottom: 1rem;
}
.content {
  padding-top: var(--padding-top);
  max-width: 100%;
  background: var(--base-1);
  flex: 1 0;
}
.content,
.search {
  --padding-top: 72px;
}
.cancel-search.hide {
  display: none;
}
sh-nav-bar {
  display: none;
}
[search-bar] {
  position: relative;
  background: var(--base-1);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  border-radius: 10rem;
  overflow: hidden;
}
[search-bar] input {
  background: none;
}
.accessBar {
  display: flex;
  flex-direction: row;
  position: fixed;
  z-index: 3;
  width: 100%;
  height: 56px;
  background: var(--base-0);
  box-shadow: var(--shadow-navigation);
  padding: 0rem;
  gap: 1rem;
  box-sizing: border-box;
  padding-left: 1rem;
  padding-right: 1rem;
}
.accessBar > * {
  z-index: unset;
  margin-top: auto;
  margin-bottom: auto;
  flex-direction: row;
}
.accessBar sh-spinner {
  max-width: 2rem;
}
[center] {
  display: flex;
  align-items: center;
  flex: 1 0;
  justify-content: center;
  margin-left: 5%;
  margin-right: 5%;
}
[center] input[disabled] {
  opacity: 0.5;
}
[center] sh-progress {
  position: absolute;
  bottom: 0px;
  left: 0.2rem;
  width: calc(100% - 0.4rem);
  height: 2px;
}
[title] {
  font-family:
    bree-headline,
    "Arial Black",
    Calibri,
    sans-serif;
  color: var(--text-primary);
  line-height: var(--sh-access-bar-label-line-height);
  text-overflow: ellipsis;
  align-self: center;
}
app-recent-system {
  width: 80%;
  max-width: 600px;
  margin: 1rem;
  height: inherit;
}
.search-info-message {
  align-items: center;
  padding-top: 2rem;
  color: var(--text-primary);
  justify-content: center;
  display: flex;
}
.search-info-message sh-icon {
  margin-right: 0.5rem;
}
.modality-note {
  max-width: 600px;
  padding: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  flex-direction: column;
}
[screen-desktop] :host-context .search,
[screen-desktop-large] :host-context .search {
  max-height: 100%;
  height: calc(100% - 56px);
  padding-bottom: 0px;
}
.checkbox {
  width: auto;
  margin-left: 1rem;
}
[screen-tablet] :host-context .content,
[screen-tablet] :host-context .search,
[screen-phone] :host-context .content,
[screen-phone] :host-context .search {
  --padding-top: 56px;
}
[screen-tablet] :host-context .cancel-search-desktop,
[screen-phone] :host-context .cancel-search-desktop {
  display: none;
}
[screen-tablet] :host-context app-authorized,
[screen-phone] :host-context app-authorized {
  width: 2rem;
}
[screen-tablet] :host-context sh-nav-bar,
[screen-phone] :host-context sh-nav-bar {
  display: initial;
}
[screen-tablet] :host-context sh-access-bar[desktop],
[screen-phone] :host-context sh-access-bar[desktop] {
  display: none;
}
[screen-tablet] :host-context app-recent-system,
[screen-phone] :host-context app-recent-system {
  width: 90%;
  max-width: 90%;
}
[screen-tablet] :host-context .advanced-search-btn,
[screen-phone] :host-context .advanced-search-btn {
  display: none;
}
[screen-tablet] :host-context .accessBar,
[screen-phone] :host-context .accessBar {
  justify-content: space-between;
}
app-recent-system {
  margin: 1rem;
}
sh-user-identifier {
  --text-secondary: var(--text-primary);
}
[email] {
  margin-left: 2.5rem;
  margin-top: -0.5rem;
  width: calc(100% - 2.5rem);
}
[logout] {
  align-self: center;
  min-width: 100%;
}
sh-drawer [icon=cancel] {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
input {
  border: 0px;
  width: 100%;
  padding: 0.5rem;
  outline: none;
  font-size: var(--font-size);
}
.desktop-search {
  width: 100%;
  display: flex;
  justify-content: center;
}
.desktop-search .cancel-search-mobile {
  display: none;
}
.advanced-search-btn {
  display: flex;
  flex-direction: column;
  padding: 0 8px;
  height: 72px;
  justify-content: center;
}
.advanced-search-btn sh-icon {
  align-self: center;
}
.advanced-search-btn sh-text {
  text-align: center;
  width: min-content;
  cursor: pointer;
}
.active-underline {
  border-bottom: 2px solid #ec6602;
}
/*# sourceMappingURL=app.component.css.map */
